import Form from './Form';
import Collection from 'Support/Collection';

export default class GroupsListForm extends Form {
    templateId() {
        return '#groupsListFormTemplate';
    }

    data() {
        return '/dashboard/profile/ajax/getGroups';
    }

    process() {
        return function (data) {
            var groupNames = Collection.collect(data.groups).pluck('name');
            return { title: 'Groups', items: Collection.collect(groupNames).itemsOrNone() };
        };
    }
}
